import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BarChartIcon from '@mui/icons-material/BarChart';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import EvStationIcon from '@mui/icons-material/EvStation';
import PortraitIcon from '@mui/icons-material/Portrait';
import BatteryCharging60Icon from '@mui/icons-material/BatteryCharging60';
import HistoryIcon from '@mui/icons-material/History';
import ProvidersIcon from '@mui/icons-material/Power';
import LogoutIcon from '@mui/icons-material/Logout';

import { logout } from '../../redux/reducers/authSlice';
import { resetChargingPoints } from '../../redux/reducers/chargingPointsSlice';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { ThemeContext, themes } from '../ThemeProvider';
import TabBar from '../Utils/TabBar';
import {selectUserType} from "../../redux/selectors/userType.js";
import {resetUserType} from "../../redux/reducers/userTypeSlice.js";
import './style.scss';
function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isAdmin, isSuperAdmin, isProviderAdmin  } = useSelector(selectUserType);
  const [selectedMenuIndex, setSelectedMenuIndex] = useState('');

  const { t } = useTranslation();
  const { theme, toggleTheme } = useContext(ThemeContext);
  const activeTabIndex = themes.indexOf(theme);

  useEffect(() => {
    if (location.pathname.includes('users')) {
      setSelectedMenuIndex('Users');
    } else if (location.pathname.includes('reports')) {
      setSelectedMenuIndex('Reports');
    } else if (location.pathname.includes('organizations')) {
      setSelectedMenuIndex('Organizations');
    } else if (location.pathname.includes('charging-points')) {
      setSelectedMenuIndex('Charging Points');
    } else if (location.pathname.includes('charging-status')) {
      setSelectedMenuIndex('Charging Status');
    } else if (location.pathname.includes('profile')) {
      setSelectedMenuIndex('Profile');
    } else if (location.pathname.includes('providers')) {
        setSelectedMenuIndex('Providers');
    } else {
      setSelectedMenuIndex('Dashboard');
    }
  }, [location, selectedMenuIndex]);

  const renderMenuItems = () => {
    const array = isSuperAdmin
      ? [
          { icon: 'Dashboard', name: t('dashboard') },
          { icon: 'Users', name: t('users') },
          { icon: 'Reports', name: t('reports') },
          { icon: 'Providers', name: t('providers') },
          { icon: 'Organizations', name: t('organizations') },
          { icon: 'Charging Points', name: t('charging_points') },
          // { name: 'Charging Status' },
          // { name: 'History' },
          { icon: 'Profile', name: t('profile') },
          { icon: 'Logout', name: t('logout') }
        ]
      : isAdmin
      ? [
          { icon: 'Dashboard', name: t('dashboard') },
          { icon: 'Users', name: t('users') },
          { icon: 'Reports', name: t('reports') },
          { icon: 'Charging Points', name: t('charging_points') },
          { icon: 'Organizations', name: t('organizations') },
          // { name: 'Charging Status' },
          // { name: 'History' },
          { icon: 'Profile', name: t('profile') },
          { icon: 'Logout', name: t('logout') }
        ]
      : isProviderAdmin ? [
                { icon: 'Dashboard', name: t('dashboard') },
                { icon: 'Users', name: t('users') },
                { icon: 'Reports', name: t('reports') },
                
                { icon: 'Organizations', name: t('organizations') },
                { icon: 'Charging Points', name: t('charging_points') },
                { icon: 'Profile', name: t('profile') },
                { icon: 'Logout', name: t('logout') }
            ] : [
          { icon: 'Dashboard', name: t('dashboard') },
          { icon: 'Profile', name: t('profile') },
          { icon: 'Logout', name: t('logout') }
        ];

    return array.map((item, index) => (
      <NavItem eventKey={item.icon} key={index}>
        <NavIcon
          style={{
            height: '100%',
            padding: '1em'
          }}>
          {returnMenuIconForTab(item.icon)}
        </NavIcon>
        <NavText>{item.name}</NavText>
      </NavItem>
    ));
  };

  const returnMenuIconForTab = (menuName) => {
    switch (menuName) {
      case 'Dashboard':
        return <DashboardIcon />;
      case 'Users':
        return <ManageAccountsIcon />;
      case 'Reports':
        return <BarChartIcon />;
      case 'Organizations':
        return <CorporateFareIcon />;
      case 'Charging Points':
        return <EvStationIcon />;
      case 'Profile':
        return <PortraitIcon />;
      case 'Charging Status':
        return <BatteryCharging60Icon />;
      case 'History':
        return <HistoryIcon />;
        case 'Providers':
            return <ProvidersIcon />
      case 'Logout':
        return <LogoutIcon />;
      default:
        return <EvStationIcon />;
    }
  };
  return (
    <div>
      <SideNav
        onSelect={(selected) => {
          if (selected === 'Logout') {
            dispatch(resetChargingPoints());
            dispatch(resetUserType())
            dispatch(logout());
            navigate('/');
          } else if (selected === 'Dashboard') {
            navigate(`/${selected.toLowerCase().replace(' ', '-')}`);
            setSelectedMenuIndex(selected);
          } else {
            navigate(`/${selected.toLowerCase().replace(' ', '-')}`);
            setSelectedMenuIndex(selected);
          }
        }}>
        <SideNav.Toggle />
        <SideNav.Nav defaultSelected={selectedMenuIndex} selected={selectedMenuIndex}>
          {renderMenuItems()}
        </SideNav.Nav>
        <TabBar
          tabs={themes.map((theme) => ({ iconName: theme, onClick: toggleTheme }))}
          activeTabIndex={activeTabIndex}
          flexColumn
          className='theme-switch'
        />
      </SideNav>
    </div>
  );
}

export default Sidebar;
